import { getDefaultCalendar } from 'owa-calendar-cache';
import { thirdPartyOnlineMeetingProviderDetails } from '../components/ThirdPartyOnlineMeetingProviderList';
import LocalCalendarEntry from 'owa-service/lib/contract/LocalCalendarEntry';

/**
 * Returns true if the defaultOnlineMeetingProvider is 3P
 */
export default function isDefaultOnlineMeetingProviderThirdParty(): boolean {
    const calendarEntry: LocalCalendarEntry = getDefaultCalendar() as LocalCalendarEntry;
    const defaultOnlineMeetingProvider = calendarEntry?.DefaultOnlineMeetingProvider;

    const allThirdPartyMeetingClientsMap = new Map(
        thirdPartyOnlineMeetingProviderDetails.map(thirdPartyOnlineMeetingProvider => [
            thirdPartyOnlineMeetingProvider.Name,
            thirdPartyOnlineMeetingProvider,
        ])
    );

    return allThirdPartyMeetingClientsMap.has(defaultOnlineMeetingProvider);
}
